import { css } from "styled-components";
import token from "styled-token";
import { buttonStateMixin } from "../buttonStateMixin";
import { sizeMixin } from "../sizeMixin";
import { spacingMixin } from "../spacingMixin";
import { typographyMixin } from "../typographyMixin";
import { disabledMixin } from "../disabledMixin";
import { focusMixin } from "../focusMixin";
import { BUTTON_SIZES } from "../../constants";
import { inlineMediaQueryMixin } from "../inlineMediaQueryMixin";
import { hoverMediaQueryMixin } from "../hoverMediaQueryMixin";

var fluidCSS = function fluidCSS(mediaProps) {
  return css(["width:", ";"], mediaProps.fluid ? "100%" : "auto");
};
/** @class ButtonMixin */

/** @method */


export var ButtonMixin = function ButtonMixin(props) {
  var size = props.size;
  return token({
    borderRadius: "Button.borderRadius",
    borderWidth: "Button.borderWidth",
    fontType: "Button.fontType" + (size === BUTTON_SIZES.sm ? "Small" : ""),
    horizontalPadding: "Button.horizontalPadding",
    targetSize: "accessibility.targetSize"
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
        borderWidth = _ref.borderWidth,
        fontType = _ref.fontType,
        horizontalPadding = _ref.horizontalPadding,
        targetSize = _ref.targetSize;
    return css(["cursor:pointer;text-decoration:none;text-align:center;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;border:", "px solid;border-radius:", "px;user-select:none;padding-left:", "px;padding-right:", "px;margin:0;-webkit-appearance:none;transition-property:background-color,border-color,color;transition-duration:0.2s;transition-timing-function:ease;", " ", " &,&:focus,&:visited,&:disabled{", "}", " &[aria-pressed=\"true\"][aria-pressed=\"true\"]{", " border-width:2px;padding-left:", "px;padding-right:", "px;", "}&:active:not(:disabled){", "}position:relative;&:after{content:\"\";position:absolute;left:0;height:", "px;min-width:", "px;width:100%;top:50%;margin-top:-", "px;}", " ", " ", " ", ""], borderWidth, borderRadius, horizontalPadding, horizontalPadding, focusMixin(props), inlineMediaQueryMixin("fluid", fluidCSS)(props), buttonStateMixin()(props), hoverMediaQueryMixin(buttonStateMixin("Hover")(props)), buttonStateMixin("Pressed")(props), horizontalPadding - 1, horizontalPadding - 1, sizeMixin({
      fontType: fontType,
      borderWidth: borderWidth * 4
    })(props), buttonStateMixin("Active")(props), targetSize, targetSize, targetSize / 2, typographyMixin(Object.assign({
      fontType: fontType
    }, props)), disabledMixin(props), sizeMixin({
      fontType: fontType,
      borderWidth: borderWidth * 2
    })(props), spacingMixin(props));
  })(props);
};